// extracted by mini-css-extract-plugin
module.exports = {"workflowPageContainer":"WorkflowStyles_workflowPageContainer__2BwKd"};